import Banner from "../components/Banner";
import About from "../components/About";
import Benefits from "../components/Benefits";
import Curriculum from "../components/Curriculum";
import Apply from "../components/Apply";
import Footer from "../components/reusable/Footer";
import Header from "../components/reusable/Header";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function Home() {
  useEffect(() => {
    AOS.init({ duration: 500 });
  }, []);
  return (
    <div className="Home">
      <Header />
      <Banner />
      <About />
      <Benefits />
      <Curriculum />
      <Apply />
      <Footer />
    </div>
  );
}

export default Home;
